import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import { useOidc } from '../providers/OidcProvider';

export interface OidcCallbackPageProps {
  errorPath?: string;
  successPath?: string;
  onError?: (error: Error) => void;
  element?: React.ReactNode;
}

export const OidcCallbackHandler = ({
  successPath = '/',
  errorPath = '/',
  element = null,
}: OidcCallbackPageProps) => {
  const { isAuthenticated, isLoading } = useOidc();
  const [params] = useState(() => new URLSearchParams(window.location.search));
  const [code] = useState(params.get('code'));
  const navigate = useNavigate();

  useEffect(() => {
    try {
      // If this contains a code parameter, it's likely a login callback
      if (code) {
        // Wait a moment to ensure auth state is updated
        if (!isLoading) {
          if (isAuthenticated) {
            navigate(successPath);
          } else {
            navigate(errorPath + '?error=OIDC Error failed to authenticate');
          }
        }
      } else {
        // If no code parameter, just redirect to home
        navigate(
          errorPath +
            '?error=OIDC Error ' +
            params.get('error') +
            ', reason: ' +
            params.get('error_description')
        );
      }
    } catch (error) {
      console.error('Authentication callback error:', error);
      navigate(errorPath + '?error=' + (error as Error).message);
    }
  }, [code, successPath, errorPath, isLoading, isAuthenticated, params, navigate]);

  return element;
};
